import { createAction, props } from '@ngrx/store';
import { TasksEntityType } from 'mojo-tasks';

export const sendNotificationAssignTask = createAction(
  '[Tasks] send notification assign Task',
  props<{
    entityType: TasksEntityType | string;
    entityId: number;
    payload: any;
    entityName?: string;
    assignedUserPhotoId?: number;
  }>(),
);

export const sendNotificationAssignTaskSuccess = createAction(
  '[Tasks] send notification assign Task Success',
);

export const tasksLoadDashboard = createAction(
  '[Tasks] Load Dashboard',
  props<{ afterEdit?: boolean }>(),
);
